module.exports = __webpack_public_path__ + "img/banner-1.33bb2c73.jpg";